import React from "react";

const PrivateGroup = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M21.38 31.14H4.86L4.32 8.6 22 8.36l-.05 1.63c.38-.33.79-.61 1.23-.85V6.77a.86.86 0 00-.05-.32.8.8 0 00-.18-.27 1.27 1.27 0 00-.27-.18.866.866 0 00-.32-.06h-.97V2.81c0-.13-.03-.26-.09-.37a.73.73 0 00-.26-.29.979.979 0 00-.37-.14c-.13-.02-.27 0-.39.05L3 5.94v25.83a1.216 1.216 0 001.23 1.2L22.27 34c.2-.01.39-.09.54-.22.15-.14.23-.32.25-.52v-4.03h-1.64l-.04 1.91z"
            fill={fill}
        />
        <path className="u_fill"
            d="M13.53 15.8c1.14 0 2.07-.9 2.07-2.02 0-1.11-.93-2.02-2.07-2.02-1.14 0-2.07.9-2.07 2.02.01 1.12.93 2.02 2.07 2.02zM17.25 17.68c0-.29-.12-.56-.32-.76-.21-.2-.49-.32-.78-.32h-5.23c-.14 0-.29.03-.42.08a1.055 1.055 0 00-.6.58c-.06.13-.08.27-.08.41v6.18h7.44v-6.17h-.01zM16.89 26.84h-6.88v1.2h6.88v-1.2zM31.99 17.22V14.9c0-1.43-.58-2.81-1.62-3.82a5.625 5.625 0 00-3.91-1.58c-1.46 0-2.88.57-3.91 1.58a5.328 5.328 0 00-1.62 3.82v2.31H19.8v10.8h13.42v-10.8h-1.23v.01zm-5.53 6.87c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm3.69-6.87h-7.38V14.9c0-.96.39-1.87 1.08-2.55.69-.68 1.63-1.05 2.61-1.05s1.92.38 2.61 1.05c.69.68 1.08 1.59 1.08 2.55v2.32z"
            fill={fill}
        />
    </svg>
);

export default PrivateGroup;